import { getProxyHosts } from "./api/course";
import { useEffect, useRef, useState } from "react";

const PROXY_PORT = "8080";
const PROBE_TIMEOUT_MS = 900;
const PROBE_OVERALL_TIMEOUT_MS = 1500; // 并行探测的整体最大等待时间 
/**
 * 代理 xhr 请求
 * @param activeProxyHost {string} 代理服务器地址，如 http://127.0.0.1:8080
 */
function proxyXhr(activeProxyHost) {
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url, ...args) {
        let targetUrl = url;
        // 请求是打向腾讯云媒体网关的
        if (url.includes('myqcloud.com') || url.includes('qcloud.com')) {
            // 【关键策略：放行解密密钥和上报网关】
            // 腾讯云的私有 DRM License (tsrc=EODrmLicense) 或包含 /key/ 的链接，绝不能走 Go 代理，必须直连外网！
            if (url.includes('tsrc=EODrmLicense') || url.includes('/key/') || url.includes('datacenter.live.qcloud.com')) {
                console.log(`[🔑 密钥/网关放行] 核心解密通道，允许直通腾讯云原厂网关`, 'hijack');
                return originalOpen.apply(this, [method, url, ...args]);
            }

            const alreadyProxied = url.includes('/tunnel') || url.includes('tunnel?target=') || (activeProxyHost && (url.startsWith(activeProxyHost) || url.startsWith(activeProxyHost.replace(/^https?:\/\//, ''))));
            if (!alreadyProxied) {
                targetUrl = `${activeProxyHost}/tunnel?target=${encodeURIComponent(url)}`;
            } else {
                console.log(`[跳过二次封装] 已检测到代理路径或已包装 URL: ${url}`, 'hijack');
            }

            // 绝杀掉包：只有真正的媒体流（.m3u8, .ts）才扭转流量流向本地 Go 服务
            // targetUrl = `${activeProxyHost}/tunnel?target=${encodeURIComponent(url)}`;
            
            if (url.includes('.m3u8')) {
                console.log(`[✨ 劫持成功] 拦截到索引文件 M3U8 -> 已强行重定向至 Go 加速服务`, 'hijack');
            } else if (url.includes('.ts')) {
                const tsName = url.substring(url.lastIndexOf('/') + 1, url.indexOf('.ts') + 3);
                console.log(`[🚀 🚀 劫持成功] 拦截到媒体切片 ${tsName} -> 强行重定向至 Go 服务`, 'success');
            }
        }
        return originalOpen.apply(this, [method, targetUrl, ...args]);
    };
}

// ping来寻找合适的主机
async function probeProxyHost(host) {
    return new Promise(async (resolve, reject) => {
        const controller = new AbortController();
        const to = setTimeout(() => controller.abort(), PROBE_TIMEOUT_MS);
        try {
            const response = await fetch(`${host}/ping`, {
                method: 'GET',
                mode: 'cors',
                signal: controller.signal
            });
            clearTimeout(to);
            const data = await response.text();
            if (data === 'pong') {
                resolve(host);
            } else {
                reject(new Error('no-pong'));
            }
        } catch (error) {
            clearTimeout(to);
            reject(error);
        }
    });
}

// 获取可用的主机
async function resolveActiveProxyHost(hosts) {
    console.log('[系统] 正在拉取已上报的局域网代理 IP 列表...');
    console.log(hosts, 'hostshostshostshosts')
    if (hosts.length === 0) {
        console.log('[系统] reported-ips 返回空列表，无法启用局域网加速。', 'error');
        return null;
    }

    // 并行探测，按第一个成功返回的 host 立刻使用；整体超时后回退
    const probePromises = hosts.map(h => probeProxyHost(h));

    try {
        const winner = await Promise.race([
            Promise.any(probePromises),
            new Promise(resolve => setTimeout(() => resolve(null), PROBE_OVERALL_TIMEOUT_MS))
        ]);

        if (winner) {
            console.log(`[系统] 并行探测命中可用代理: ${winner}`, 'success');
            return winner;
        }
    } catch (e) {
        console.log(e, 'resolveActiveProxyHost-error')
        // Promise.any 在全部失败时会 reject
    }

    console.log('[系统] 并行探测超时或未命中，快速回退原厂直连。', 'error');
    return null;
}

// 组装返回的数据
async function fetchReportedProxyHosts() {
    const response = await getProxyHosts()
    if (!response.status === 200) {
        throw new Error(`reported-ips 接口返回 ${response.status}`);
    }
    try {
        const hosts = response.data
        if (!hosts || !Array.isArray(hosts)) {
            throw new Error('reported-ips 返回结构异常');
        }
        const activeHost = resolveActiveProxyHost(hosts.map(host => `http://${host}:${PROXY_PORT}`))
        return activeHost
    } catch(e) {
        console.log(e.message, '错误信息')
    }
}

export function useTcplayerCdn () {
    const [isSpeedUpActive, setIsSpeedUpActive] = useState()
    const cdnOriginRef = useRef(null)
    // 如果cdn可用
    if (isSpeedUpActive) {
        proxyXhr(cdnOriginRef.current)
    }
    useEffect(() => {
        const init = async() => {
            const activeOrigin = await fetchReportedProxyHosts();
            // 激活的域
            if (!activeOrigin) {
                console.log('[系统] reported-ips 返回空列表，无法启用局域网加速。', 'error');
                setIsSpeedUpActive(false)
                cdnOriginRef.current = null
                return null;
            }
            cdnOriginRef.current = activeOrigin
            setIsSpeedUpActive(true)
        }
        init()
    }, [])
}